"use client";

import { Link } from "@/component/link";
import { Button, Card, CardBody, CardFooter, CardHeader } from "@heroui/react";

export const tutorialsItems = [
  {
    title: "Ecommerce data extraction",
    description:
      "Learn how to extract product information, prices, and images from any ecommerce website with ApiFrom.",
    image: "/assets/tut-ecom/tut-ecom-4.png",
    href: "/tutorials/ecommerce-data-extraction",
    isDisabled: false,
  },
  {
    title: "News and blog scraping",
    description:
      "Extract news and blog posts from websites for analysis or aggregation.",
    image: "/assets/tut-news/tut-news-4.png",
    href: "/tutorials/news-and-blog-scraping",
    isDisabled: false,
  },
];

export default function TutorialsPage() {
  return (
    <div className="container px-6 py-12 mx-auto">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl font-bold mb-4">Tutorials</h1>
        <p className="text-lg opacity-70 max-w-2xl mx-auto">
          Learn how to extract structured data from any website with our
          step-by-step tutorials. No coding required!
        </p>
      </div>

      <div className="mt-16 flex flex-wrap gap-8 justify-center">
        {tutorialsItems.map((tutorial, index) => (
          <Card
            key={index}
            className="group overflow-hidden flex flex-col max-w-80"
          >
            <CardHeader className="p-0">
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={tutorial.image}
                  alt={`${tutorial.title} tutorial`}
                  className="object-cover transition-transform group-hover:scale-105"
                />
              </div>
            </CardHeader>
            <CardBody className="flex flex-col flex-1">
              <h2 className="text-xl font-bold mb-2">{tutorial.title}</h2>
              <p className="opacity-70 mb-4 flex-1">{tutorial.description}</p>
            </CardBody>
            <CardFooter>
              <Link
                href={tutorial.href}
                isDisabled={tutorial.isDisabled}
                className="text-primary font-medium hover:underline"
              >
                {tutorial.isDisabled ? "Coming Soon →" : "Read tutorial →"}
              </Link>
            </CardFooter>
          </Card>
        ))}
      </div>

      <div className="mt-16 text-center">
        <h2 className="text-2xl font-bold mb-4">
          Need Help with a specific use case?
        </h2>
        <p className="max-w-2xl mx-auto mb-8 opacity-70">
          Can't find what you're looking for? Contact us for personalized
          assistance with your specific data extraction needs.
        </p>
        <Button
          as={Link}
          href="/contact"
          className="bg-primary text-primary-foreground"
        >
          Contact Us
        </Button>
      </div>
    </div>
  );
}
